<template>
  <div>
    <v-layout v-if="canViewPrices" pb-4 mr-4>
      <v-flex v-if="currentStep > 1 && currentStep < 3" sm12 text-sm-right
        >Order Total: {{ orderTotal }}</v-flex
      >
    </v-layout>
    <v-flex xs12 text-xs-center>
      <v-stepper v-model="currentStep" vertical>
        <v-stepper-step
          @click="setStepper(1)"
          step="1"
          edit-icon="person"
          editable
          >Select Customer</v-stepper-step
        >
        <v-stepper-content step="1">
          <v-layout wrap mt-4>
            <v-flex xs12 sm8 md4 mr-6>
              <v-autocomplete
                dense
                v-model="order.company"
                :items="customers"
                item-text="name"
                item-value="_id"
                label="Search for customer*"
                outlined
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout v-if="order.company" wrap>
            <v-flex xs12 sm8 md4 mr-6>
              <v-autocomplete
                dense
                v-model="orderFrom"
                :items="orderFromOptions"
                label="Select products from*"
                outlined
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout v-if="orderFrom === 'Template'" wrap>
            <v-flex xs12 sm8 md4 mr-6>
              <v-autocomplete
                v-model="orderTemplate"
                dense
                :items="templates"
                item-text="name"
                item-value="_id"
                label="Select order template*"
                outlined
              ></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-stepper-content>
        <v-stepper-step @click="setStepper(2)" step="2" editable offset-xs-6
          >Select Products</v-stepper-step
        >
        <v-stepper-content step="2">
          <div v-if="orderFrom === 'Template'">
            <template-order
              v-if="template"
              :template="template"
              :distributorLocations="distributorLocations"
            />
          </div>
          <div v-if="orderFrom === 'Product Catalog'">
            <catalog
              :categories="categories"
              :distributorLocations="distributorLocations"
              :companyId="selectedCustomer._id"
              @addItem="addItem"
            />
          </div>
        </v-stepper-content>
        <v-stepper-step
          @click="
            setStepper(3);
            checkDistributors();
          "
          step="3"
          editable
          offset-xs-6
          >Finalize Order</v-stepper-step
        >
        <v-stepper-content step="3">
          <v-layout wrap v-if="selectedCustomer" mt-4>
            <v-flex xs12 sm8 md4 pr-4>
              <v-layout wrap>
                <v-flex xs12>
                  <v-autocomplete
                    :items="[...selectedCustomer.shippingAddresses]"
                    @change="setDistributors()"
                    outlined
                    dense
                    :key="order.shipToId"
                    autocomplete="abc"
                    label="Select Shipping Address*"
                    v-model="order.shipToId"
                    item-text="formatted_address"
                    item-value="_id"
                  >
                    <template v-slot:item="data">
                      <v-layout>
                        <address-list-item :address="data.item" />
                      </v-layout>
                    </template>
                    <template v-slot:append-item>
                      <v-layout justify-center>
                        <v-btn
                          @click="initiateAddress('shippingAddress')"
                          color="primary"
                          >Add Shipping Address</v-btn
                        >
                      </v-layout>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    :items="[...selectedCustomer.billingAddresses]"
                    outlined
                    dense
                    autocomplete="abc"
                    label="Select Billing Address*"
                    v-model="order.billToId"
                    item-text="formatted_address"
                    item-value="_id"
                  >
                    <template v-slot:item="data">
                      <address-list-item :address="data.item" />
                    </template>
                    <template v-slot:append-item>
                      <v-layout justify-center>
                        <v-btn
                          @click="initiateAddress('billingAddress')"
                          color="primary"
                          >Add Billing Address</v-btn
                        >
                      </v-layout>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <EmailSelector
                    email-selector-label="Email Customers*"
                    :selected-emails.sync="order.emailCustomers"
                    :email-index="0"
                    :options="customerEmails"
                    multiple
                    pricing-option
                  />
                </v-flex>
                <v-flex xs12>
                  <EmailSelector
                    email-selector-label="Email Internally*"
                    :selected-emails.sync="order.emailInternally"
                    :email-index="0"
                    :options="customerEmails"
                    multiple
                    pricing-option
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="PO # (optional)"
                    outlined
                    dense
                    v-model="order.poNum"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm4 md4 pr-4>
              <v-textarea
                outlined
                textarea
                label="Special Instructions (optional)"
                v-model="order.specialInstructions"
                rows="10"
              />
            </v-flex>

            <v-flex xs12 sm8 md4 pl-2 pr-2> </v-flex>
          </v-layout>

          <v-layout>
            <v-flex text-sm-center>
              <v-alert icon="shopping_cart" color="primary" text>
                <v-flex style="float: left">Order Items</v-flex>
              </v-alert>
            </v-flex>
          </v-layout>
          <v-layout :key="orderItemsKey">
            <v-flex>
              <v-data-table
                :dense="true"
                :headers="productTableHeaders"
                :items="selectedItems"
                hide-default-footer
              >
                <template v-slot:item.quantity="{ item }">
                  <v-text-field
                    outlined
                    type="number"
                    dense
                    min="0"
                    label="Qty"
                    class="mt-4 pa-2"
                    @input="
                      calculateOrderTotal();
                      checkValidAmt();
                    "
                    v-model="item.quantity"
                  />
                </template>
                <template v-slot:item.distributor="{ item }">
                  <v-autocomplete
                    :items="distributorLocations"
                    :key="updateDistributorKey"
                    dense
                    outlined
                    label="Distributor"
                    item-value="_id"
                    class="mt-4 pa-2"
                    item-text="address.name"
                    @input="checkDistributors"
                    v-model="item.distributor"
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ data.item.distributor.name }} |
                            {{ data.item.address.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle>{{
                            data.item.address.formatted_address
                          }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                    <template slot="selection" slot-scope="data">
                      <template>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title
                              >{{ data.item.distributor.name }} |
                              {{ data.item.address.name }}</v-list-item-title
                            >
                            <v-list-item-subtitle>
                              {{ data.item.address.formatted_address }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </template>
                  </v-autocomplete>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout v-if="canViewPrices" pb-4 mr-4>
            <v-flex sm12 text-sm-right>Order Total: {{ orderTotal }}</v-flex>
          </v-layout>
        </v-stepper-content>
      </v-stepper>

      <v-layout pt-4 mb-12>
        <v-flex v-if="currentStep > 1" sm12 text-sm-left>
          <v-btn @click="previousStep" color="primary">Back</v-btn>
        </v-flex>
        <v-flex v-if="currentStep < 3" sm12 text-sm-right>
          <v-btn
            @click="
              nextStep();
              checkDistributors();
            "
            color="primary"
            >Continue</v-btn
          >
        </v-flex>
        <v-flex
          v-if="currentStep === 3 || currentStep === '3'"
          sm12
          text-sm-right
        >
          <v-btn @click="submitOrder" color="primary" :disabled="!validOrder"
            >Submit Order</v-btn
          >
        </v-flex>
      </v-layout>
    </v-flex>
    <address-modal
      v-if="addressModal"
      title="Add Address"
      :addressModal.sync="addressModal"
      :address="baseAddress"
      :distributors="distributorLocations"
      @save="addAddress"
    />
  </div>
</template>

<script>
import request from "@/modules/request";
import { uniqBy } from "lodash";
import TemplateOrder from "./TemplateOrder";
import AddressListItem from "@/components/shared/AddressListItem";
import stepperMixin from "../../../mixins/stepperMixin";
import Catalog from "./Catalog";
import EmailSelector from "@/components/shared/EmailSelector";
import AddressModal from "@/components/shared/modals/AddressModal";
import CompanyService from "@/services/companies/company.service";
import { hasPermission } from "@/modules/rbac/permission-manifest";

export default {
  name: "AssociateCreateOrder",
  inject: ["snackBar", "reactiveInjected"],
  mixins: [stepperMixin],
  components: {
    TemplateOrder,
    AddressListItem,
    Catalog,
    EmailSelector,
    AddressModal,
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    "order.shipToId"(val) {
      this.setCustomerEmailOptions(val);
    },
    template: {
      handler(template) {
        if (template.items) {
          this.selectedItems = template.items.filter(
            (item) => parseInt(item.quantity) > 0
          );
        }
      },
      deep: true,
    },
    "order.company"() {
      const { order } = this;
      this.selectedCustomer = this.customers.find(
        (customer) => customer._id === order.company
      );
      this.order.emailCustomers = this.selectedCustomer.shippingAddresses[0].meta.emailSettings.filter(
        (email) => email.event === "order-created"
      );
      this.order.shipToId = this.selectedCustomer.shippingAddresses[0]._id;
      this.order.billToId = this.selectedCustomer.billingAddresses[0]._id;
    },
    orderFrom(value) {
      this.order.items = [];
      if (value === "Product Catalog") {
        this.currentStep = 2;
      } else {
        this.getTemplates();
      }
    },
    orderTemplate(templateId) {
      if (templateId) {
        this.getTemplate(templateId);
        this.currentStep = 2;
      }
    },
    selectedItems: {
      handler(selectedItems) {
        this.calculateOrderTotal();
      },
      deep: true,
    },
  },
  data() {
    return {
      orderTotal: "$0.00",
      order: {
        items: [],
        poNum: null,
        specialInstructions: null,
        shipToId: null,
        billToId: null,
        company: null,
        specialInstructions: null,
        emailInternally: [],
        emailCustomers: this.selectedCustomer
          ? this.selectedCustomer.emailSettings.filter(
              (email) => email.event === "order-created"
            )
          : [],
      },
      orderItems: [],
      templates: [],
      customers: [],
      distributorLocations: [],
      validDistributors: false,
      validOrderAmt: true,
      orderFromOptions: ["Product Catalog", "Template"],
      orderFrom: null,
      orderTemplate: null,
      template: null,
      selectedCustomer: null,
      selectedItems: [],
      productTableHeaders: [
        {
          text: "Product ID",
          value: "productCode",
          width: "10%",
        },
        {
          text: "Manufacturer",
          value: "manufacturer",
        },
        {
          text: "Category",
          value: "category.name",
        },
        {
          text: "Description",
          value: "description[0].value",
          width: "35%",
        },
        {
          text: "Customer Price",
          value: "price.formattedPrice",
          width: "10%",
        },
        {
          text: "Qty",
          value: "quantity",
          sortable: false,
          width: "10%",
        },
        {
          text: "Distributor",
          value: "distributor",
          sortable: false,
          width: "10%",
        },
      ],
      orderItemsKey: 0,
      categories: [],
      customerEmails: [],
      updateDistributorKey: 0,
      baseAddress: null,
      addressType: null,
      addressModal: false,
      companyService: new CompanyService(),
      canViewPrices: hasPermission(
        "canReadCustomerPricing",
        null,
        this.reactiveInjected.activeUser
      ),
    };
  },
  computed: {
    validOrder() {
      const {
        shipToId,
        billToId,
        emailCustomers,
        emailInternally,
      } = this.order;
      const { selectedItems, validDistributors, validOrderAmt } = this;
      return (
        shipToId &&
        billToId &&
        emailCustomers.length &&
        emailInternally.length &&
        selectedItems.length &&
        validDistributors &&
        validOrderAmt
      );
    },
  },
  methods: {
    addAddress(address) {
      const { selectedCustomer, addressType } = this;
      const companyId = selectedCustomer._id;
      const updatedAddresses =
        addressType === "shippingAddress"
          ? {
              shippingAddresses: [
                ...selectedCustomer.shippingAddresses,
                address,
              ],
            }
          : {
              billingAddresses: [...selectedCustomer.billingAddresses, address],
            };

      this.companyService
        .associateUpdateCompany(companyId, updatedAddresses)
        .then((results) => {
          const updatedFields = results.data;
          const customerIndex = this.customers.findIndex(
            (comp) => comp._id === companyId
          );
          this.customers[customerIndex] = {
            ...this.customers[customerIndex],
            ...updatedFields,
          };
          this.selectedCustomer = {
            ...this.selectedCustomer,
            ...updatedFields,
          };

          if (this.addressType === "shippingAddress") {
            this.order.shipToId = updatedFields.shippingAddresses.slice(
              -1
            )[0]._id;
          } else {
            this.order.billToId = updatedFields.billingAddresses.slice(
              -1
            )[0]._id;
          }

          this.snackBar("Address added", "success");
        })
        .catch((error) => {
          console.error(`Error adding address: ${error}`);
          this.snackBar("Error adding address", "error");
        });
      this.addressModal = false;
    },
    setCustomerEmailOptions(shipToId) {
      this.customerEmails = [];
      const { selectedCustomer } = this;
      const selectedAddress = this.selectedCustomer.shippingAddresses.find(
        (address) => address._id === shipToId
      );
      const addressEmailSettings = selectedAddress.meta.emailSettings;
      let customerEmailOptions = [];
      if (selectedCustomer) {
        const userEmails = selectedCustomer.users.map((user) => user.email);
        const rawGeneralEmails = [...userEmails];

        if (selectedCustomer.email) {
          rawGeneralEmails.push(selectedCustomer.email);
        }

        const formattedGeneralEmails = rawGeneralEmails
          .filter((email) => {
            const emailInSettings = addressEmailSettings.find(
              (elem) => elem.email === email
            );
            if (!emailInSettings) {
              return email;
            }
          })
          .map((email) => {
            return {
              email,
              includePricing: false,
            };
          });
        customerEmailOptions = uniqBy(
          [...formattedGeneralEmails, ...addressEmailSettings],
          "email"
        );
      }
      this.customerEmails = customerEmailOptions;
      this.order.emailCustomers = addressEmailSettings.filter(
        (email) => email.event === "order-created"
      );
    },
    checkDistributors() {
      this.validDistributors = this.selectedItems.every(
        (item) => item.distributor
      );
    },
    initiateAddress(addressType) {
      this.baseAddress = {
        formatted_address: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        meta: {},
      };

      if (addressType === "shippingAddress") {
        this.baseAddress.meta.distributorSettings = this.initializeDistributorSettings();
        this.baseAddress.meta.emailSettings = [];
      }
      this.addressType = addressType;
      this.addressModal = true;
    },
    initializeDistributorSettings() {
      const { categories } = this;
      return categories.map((category) => {
        return {
          category: category._id,
          name: category.name,
          distributor: null,
        };
      });
    },
    setDistributors() {
      const { orderFrom } = this;
      const orderShipToId = this.order.shipToId;

      const shippingAddress = this.selectedCustomer.shippingAddresses.find(
        (address) => address._id === orderShipToId
      );

      const distributorSettings = shippingAddress.meta.distributorSettings;

      if (orderFrom === "Template") {
        this.template.items.forEach((item, index) => {
          const category = item.category._id;
          const setting = distributorSettings.find(
            (elem) => elem.category === category
          );
          if (setting) {
            this.template.items[index].distributor = setting.distributor;
          }
        });
      } else if (orderFrom === "Product Catalog") {
        this.selectedItems.forEach((item, index) => {
          const category = item.category._id;
          const setting = distributorSettings.find(
            (elem) => elem.category === category
          );
          if (setting) {
            this.selectedItems[index].distributor = setting.distributor;
          }
        });

        this.updateDistributorKey += 1;
      }
    },
    checkValidAmt() {
      this.validOrderAmt = this.selectedItems.some(
        (item) => Number(item.quantity) > 0
      );
    },
    calculateOrderTotal() {
      const { canViewPrices } = this;

      if (canViewPrices) {
        // TODO - handle additional costs
        const { selectedItems } = this;
        const rawTotal = !selectedItems.length
          ? 0
          : selectedItems.reduce((total = 0, item) => {
              const { quantity, price } = item;
              const { rawPrice } = price;
              return (total += rawPrice * parseInt(quantity));
            }, 0);

        const orderTotal = rawTotal.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });

        this.orderTotal = orderTotal;
      }
    },
    async submitOrder() {
      if (this.orderFrom === "Template") {
        this.order.items = this.template.items
          .filter((item) => {
            return Number(item.quantity) > 0;
          })
          .map((item) => {
            const { _id, distributor, quantity } = item;
            return {
              _id,
              distributor,
              quantity,
            };
          });
      } else {
        this.order.items = this.selectedItems.filter((item) => {
          return Number(item.quantity) > 0;
        });
      }
      await request
        .callInternal({
          method: "post",
          route: "/api/order",
          data: this.order,
        })
        .then(() => {
          this.$swal({
            title: "Congratulations!",
            text: `Your order has been submitted.`,
            icon: "success",
          });
          this.loadData();
          this.currentStep = 1;
        })
        .catch((error) => {
          console.error(error);
        });
      this.orderItems = [];
      this.selectedItems = [];
    },
    resetData() {
      this.order = {
        company: null,
        items: [],
        poNum: null,
        specialInstructions: null,
        shipToId: null,
        billToId: null,
        company: null,
        specialInstructions: null,
        emailCustomers: [],
        emailInternally: [],
      };

      this.orderFrom = null;
      this.orderTemplate = null;
      this.template = null;
      this.selectedCustomer = null;
      this.orderItems = [];
      this.selectedItems = [];
    },
    async loadData() {
      const {
        getDistributors,
        getCustomers,
        getInternalEmails,
        getCategories,
      } = this;
      const results = await Promise.all([
        getDistributors(),
        getCustomers(),
        getInternalEmails(),
        getCategories(),
      ])
        .then((results) => {
          return results;
        })
        .catch((error) => {
          console.error(error);
        });

      const [
        distributorLocations,
        customers,
        internalEmails,
        categories,
      ] = results;

      this.distributorLocations = distributorLocations;
      this.customers = customers;
      this.order.emailInternally = internalEmails.to;
      this.categories = categories;
    },
    getCategories() {
      const opts = {
        method: "get",
      };
      return request
        .callInternal({
          method: "get",
          route: "/api/admin/fullcategories",
        })
        .then((results) => {
          return results.data;
        });
    },
    async getInternalEmails() {
      return request
        .callInternal({
          method: "get",
          route: `/api/admin/client/to-new-order-to-admins`,
        })
        .then((results) => {
          return results.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getTemplate(templateId) {
      const companyId = this.selectedCustomer._id;
      return request
        .callInternal({
          method: "get",
          route: `/api/template/${templateId}/?company=${companyId}`,
        })
        .then((results) => {
          this.template = results.data;
          this.setDistributors();
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getDistributors() {
      return request
        .callInternal({
          method: "get",
          route: "/api/admin/distributorlocations",
        })
        .then((results) => {
          return results.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getCustomers() {
      return request
        .callInternal({
          method: "get",
          route: "/api/admin/companies",
        })
        .then((results) => {
          return results.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getTemplates() {
      return request
        .callInternal({
          method: "get",
          route: `/api/templates/?company=${this.order.company}`,
        })
        .then((results) => {
          this.templates = results.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    addItem(ctx) {
      const { item, quantity } = ctx;
      const selectedItemIndex = this.selectedItems.findIndex(
        (elem) => elem._id === item._id
      );
      if (selectedItemIndex === -1) {
        item.quantity = quantity;
        this.selectedItems.push(item);
      } else {
        const currentQuantity = parseInt(
          this.selectedItems[selectedItemIndex].quantity
        );
        this.selectedItems[selectedItemIndex].quantity =
          currentQuantity + parseInt(quantity);
      }
      this.calculateOrderTotal();
      this.setDistributors();
      this.orderItemsKey += 1;
      this.snackBar("Added item", "success");
    },
    removeItem() {},
  },
};
</script>

<style scoped>
/* TODO - combine this css style */
.v-data-table >>> .v-data-table__wrapper td,
.v-data-table >>> .v-data-table__wrapper th {
  padding: 5px;
}

@media all and (max-width: 640px) {
  .v-data-table >>> .v-data-table__wrapper table,
  .v-data-table >>> .v-data-table__wrapper thead,
  .v-data-table >>> .v-data-table__wrapper tbody,
  .v-data-table >>> .v-data-table__wrapper th,
  .v-data-table >>> .v-data-table__wrapper td,
  .v-data-table >>> .v-data-table__wrapper tr {
    display: block;
  }
  .v-data-table >>> .v-data-table__wrapper td {
    height: auto;
    border: none !important;
  }

  .v-data-table >>> .v-data-table__wrapper tr {
    padding: 5px;
  }

  .v-data-table >>> .v-data-table__wrapper .v-data-table__mobile-row__cell {
    text-align: left !important;
  }

  .v-data-table >>> .v-data-table__wrapper tr:nth-of-type(even) {
    background: #eee;
  }

  .v-data-table >>> .v-data-table__wrapper th {
    margin-bottom: 15px;
    border: none !important;
  }
}
</style>
